import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";

import { saveMemo, addMemo, setTabCategory } from "common/actions";
import { getTabColor, getFilterdMemos } from "common/store";
import { title } from "common/assets/js/textSplitter";

import Menu from "components/Menu";
import Tabs from "components/Tabs";
import MemoList from "components/MemoList";
import InputArea from "components/InputArea";
import ModalMoveMemo from "components/ModalMoveMemo";

const uuid = require("uuid/v1");
class Editor extends React.Component<
  {
    categories;
    memos;
    addMemo;
    setTabCategory;
    saveMemo;
    common;
  },
  { selectedMemoId; moveMemoId; isMobileModalOpen: boolean }
> {
  constructor(props) {
    super(props);
    this.state = {
      selectedMemoId: null,
      moveMemoId: null,
      isMobileModalOpen: false,
    };
  }

  componentDidUpdate(prevProps) {
    const { categories } = this.props;
    if (prevProps.categories.nowTabCategory !== categories.nowTabCategory) {
      this.setState({
        selectedMemoId: getFilterdMemos(categories.nowTabCategory).length
          ? getFilterdMemos(categories.nowTabCategory)[0].id
          : null,
        isMobileModalOpen: false,
      });
    }
  }

  componentDidMount() {
    const { categories, memos } = this.props;
    const firstMemo = getFilterdMemos(categories.nowTabCategory)[0];
    if (firstMemo && memos[firstMemo.id]) {
      this.setState({
        selectedMemoId: firstMemo.id,
      });
    }

    //タブとメモ変更のショートカット
    window.addEventListener("keydown", this._keydown);
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this._keydown);
  }

  _keydown = e => {
    // console.log(e);
    const { selectedMemoId } = this.state;
    const { categories } = this.props;
    const nowMemoList = getFilterdMemos(categories.nowTabCategory);
    // option + n で新規作成
    if (e.keyCode === 78 && e.altKey) {
      const id = uuid();
      this.props.addMemo({ id, cat: categories.nowTabCategory });
      this._selectMemo(id);
      e.preventDefault();
    }

    const nowMemoIndex = nowMemoList.findIndex(
      memo => memo.id === selectedMemoId
    );
    // option + 上
    if (e.keyCode === 38 && e.altKey && e.shiftKey && selectedMemoId) {
      this._selectMemo(
        nowMemoIndex > 0
          ? nowMemoList[nowMemoIndex - 1].id
          : nowMemoList[nowMemoList.length - 1].id
      );
    }
    // option + 下
    if (e.keyCode === 40 && e.altKey && e.shiftKey && selectedMemoId) {
      this._selectMemo(
        nowMemoIndex < nowMemoList.length - 1
          ? nowMemoList[nowMemoIndex + 1].id
          : nowMemoList[0].id
      );
    }
    // option + 右
    if (e.keyCode === 39 && e.altKey && e.shiftKey) {
      this.props.setTabCategory(
        categories.order[
          categories.order.indexOf(categories.nowTabCategory) !==
          categories.order.length - 1
            ? categories.order.indexOf(categories.nowTabCategory) + 1
            : 0
        ]
      );
    }
    // option + 左
    if (e.keyCode === 37 && e.altKey && e.shiftKey) {
      this.props.setTabCategory(
        categories.order[
          categories.order.indexOf(categories.nowTabCategory) > 0
            ? categories.order.indexOf(categories.nowTabCategory) - 1
            : categories.order.length - 1
        ]
      );
    }
  };

  _selectMemo = selectedMemoId => {
    this.setState({
      selectedMemoId,
      isMobileModalOpen: window.innerWidth <= 768,
    });
  };

  _selectMoveMemo = moveMemoId => {
    this.setState({ moveMemoId });
  };

  _changeText = text => {
    const { selectedMemoId } = this.state;
    this.props.saveMemo({ id: selectedMemoId, text });
  };

  _onCloseMoveMemoModal = () => {
    this.setState({ moveMemoId: null });
  };

  _closeMobileModal = () => {
    this.setState({ isMobileModalOpen: false });
  };

  _addMemo = () => {
    const { categories } = this.props;
    const id = uuid();
    this.props.addMemo({ id, cat: categories.nowTabCategory });
    this._selectMemo(id);
  };

  render() {
    const { memos, common, categories } = this.props;
    const { selectedMemoId, moveMemoId, isMobileModalOpen } = this.state;
    const activeColor = getTabColor(categories.nowTabCategory);
    const selectedMemo = selectedMemoId && memos[selectedMemoId];
    return (
      <Wrapper activeColor={activeColor}>
        <Tabs selectedMemoId={selectedMemoId} />
        <div className="editorArea">
          <MemoList
            onSelectMemo={this._selectMemo}
            onSelectMoveMemo={this._selectMoveMemo}
            selectedMemoId={selectedMemoId}
          />
          <div className="editorContent">
            {selectedMemo ? (
              <InputArea
                selectedMemoId={selectedMemoId}
                changeText={this._changeText}
                text={selectedMemo.text}
              />
            ) : (
              <p className="noSelectedText">
                左下の「メモを追加」ボタンでメモを追加しましょう。
              </p>
            )}
          </div>
          {categories.nowTabCategory && (
            <button className="addBtn" onClick={this._addMemo}>
              メモを追加
            </button>
          )}
        </div>
        {isMobileModalOpen && selectedMemo && (
          <MobileModal activeColor={activeColor}>
            <div className="modalHeader">
              <button className="backBtn" onClick={this._closeMobileModal}>
                <i className="fas fa-arrow-left" />
              </button>
              <span className="memoTitle">{title(selectedMemo.text)}</span>
            </div>
            <InputArea
              selectedMemoId={selectedMemoId}
              changeText={this._changeText}
              text={selectedMemo.text}
            />
          </MobileModal>
        )}
        {common.isMenuOpen && <Menu />}
        {moveMemoId && (
          <ModalMoveMemo
            memoId={moveMemoId}
            onClose={this._onCloseMoveMemoModal}
          />
        )}
      </Wrapper>
    );
  }
}
export default connect(
  ({ user, categories, memos, common }) => ({
    user,
    categories,
    memos,
    common,
  }),
  { saveMemo, addMemo, setTabCategory }
)(Editor);

const Wrapper = styled.div<{ activeColor: string }>`
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  .noSelectedText {
    padding: 12px 16px;
    color: #999;
  }
  .editorArea {
    display: flex;
    overflow: hidden;
    flex: 1;
  }
  .editorContent {
    display: flex;
    flex: 1;
    overflow: hidden;
  }
  .addBtn {
    position: absolute;
    left: 8px;
    bottom: 8px;
    width: ${250 - 16}px;
    background-color: ${props => props.activeColor};
    color: #fff;
    padding: 8px;
    border-radius: 4px;
  }
  @media (max-width: 768px) {
    .editorArea {
      > *:first-child {
        width: 100%;
      }
      .editorContent {
        display: none;
      }
    }
    .addBtn {
      width: calc(100% - 16px);
    }
  }
`;

const MobileModal = styled.div<{ activeColor: string }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  background: #fff;
  display: flex;
  flex-direction: column;
  .modalHeader {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #eee;
    background-color: ${props => props.activeColor};
    color: #fff;
    .backBtn {
      color: #fff;
      margin-right: 12px;
      font-size: 18px;
      padding: 4px 8px;
    }
    .memoTitle {
      font-size: 16px;
      font-weight: bold;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`;
